import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, Book, Smartphone, Zap } from 'lucide-react';
const features = [{
  icon: Cloud,
  title: 'Cloud-Based Access',
  description: 'No downloads required. Access your entire library directly from the cloud on any device with an internet connection.'
}, {
  icon: Book,
  title: 'Curated Collection',
  description: 'Our team of experts hand-picks titles to ensure quality and relevance across all genres and categories.'
}, {
  icon: Smartphone,
  title: 'Cross-Device Sync',
  description: 'Start reading on your laptop and pick up exactly where you left off on your tablet or phone.'
}, {
  icon: Zap,
  title: 'Instant Availability',
  description: 'New titles are available instantly. No waiting periods or hold queues for digital content.'
}];
export function OurServicePage() {
  return <main className="flex-1 bg-background" data-id="element-295">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-296">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-297">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-298">
            Our Service
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-299">
            Bluecore offers subscription-based access to curated digital books,
            designed for modern readers.
          </motion.p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-302">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-303">
              <h2 className="text-3xl font-bold text-slate-dark mb-6" data-id="element-304">
                Seamless Digital Reading
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-305">
                Bluecore transforms how you access digital content. Unlike
                traditional ebook stores where you purchase individual titles,
                our subscription model gives you access to a vast, rotating
                library of premium content.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-306">
                Our platform is entirely cloud-based, meaning there's no
                software to install and no complex setup process. Simply log in,
                browse our curated collection, and start reading immediately.
                It's reading made simple, efficient, and accessible.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative aspect-video rounded-2xl overflow-hidden shadow-xl bg-slate-100" data-id="element-307">
              <img src="https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&q=80&w=1000" alt="Digital library on tablet" className="w-full h-full object-cover" data-id="element-308" />
            </motion.div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-309">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-slate-50 p-6 rounded-xl border border-slate-100 hover:shadow-md transition-shadow" data-id="element-310">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center text-primary shadow-sm mb-4" data-id="element-311">
                  <feature.icon className="w-6 h-6" data-id="element-312" />
                </div>
                <h3 className="font-bold text-slate-dark mb-2" data-id="element-313">
                  {feature.title}
                </h3>
                <p className="text-sm text-slate-600" data-id="element-314">{feature.description}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </main>;
}